import { Container } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Datagrid, FunctionField, List, TextField, useListContext, useListController, useTranslate } from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PostFilterFormSupplierBilling, SupplierBillingFilters } from './logic/SupplierBillingFilters'
import { FormattedTextFieldWithStatus } from '../../sales/reservation/helper/FormattedTextFieldWithStatus'

export const SupplierBillingList = (props) => {
    const translate = useTranslate()
    const { isFetching, page, filterValues } = useListContext()
      const prevPageRef = useRef()
    
      const prevFiltersRef = useRef(filterValues)
    
      const [pageChanged, setPageChanged] = useState(false)
    
      useEffect(() => {
        // Comprobar si la página ha cambiado y si isFetching es true
        if (prevPageRef.current !== page && isFetching) {
          prevPageRef.current = page
          setPageChanged(true)
        }
        if (prevFiltersRef.current !== filterValues && isFetching) {
          prevFiltersRef.current = filterValues
          setPageChanged(true)
        } else {
          setPageChanged(false)
        }
      }, [isFetching, page, filterValues])

    const hasPermissions = () => {
        return(
            hasPermissionFunction('supplier-billing', 'edit') ||
            hasPermissionFunction('supplier-billing', 'delete')
        )
    }

    const allFilters = [
      { source: 'date', name: 'ra.field.date' },
      { source: 'document_type', name: 'ra.field.document_type' },
      { source: 'document_number__ilike', name: 'ra.field.document_number' },
      { source: 'supplier_id', name: 'ra.field.supplier' },
      { source: 'due_date', name: 'ra.field.due_date' },
      { source: 'created_at', name: 'ra.field.created_at' },
    ]
  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.supplier-billing')}>
        <List {...props} sort={{field: 'id', order: 'DESC'}} component='div' actions={<ListViewTopToolbar customFilter FilterFormComponent={PostFilterFormSupplierBilling} FilterButtonComponent={SupplierBillingFilters} listFilters={allFilters}/>}>
          <Datagrid  /* setSort={onClickSort} */ isLoading={pageChanged}>
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField source='supplier_name' label={translate('ra.field.supplier')} sortable={false}/>
            <TextField source='code' label={translate('ra.field.code')} sortable={false}/>
            <TextField source='amount' label={translate('ra.field.amount')} />
            <TextField source='date' label={translate('ra.field.created_at')} />
            {/* <TextField source='status' label={translate('ra.field.status')} /> */}
            <FormattedTextFieldWithStatus label={translate('ra.field.status')} source='status' />
            <TextField source='document_number' label={translate('ra.field.document_number')} />
            <FunctionField render={record => translate(`ra.field.${record.document_type}`)} source='document_type' label={translate('ra.field.document_type')} />
            <TextField source='due_date' label={translate('ra.field.due_date')} />
            {hasPermissions() && (
              <ListViewActionsButtons label={translate('ra.action.actions')} fieldsName={['short_name']} genderElement='femenine' disableRevision />
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
